import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';

import * as d3 from 'd3';
import {TemperatureUnit} from '../../../../shared';
import {Airnote} from '../../../../afb-api/models/airnote';

@Component({
  selector: '[awair-big-dot]',
  templateUrl: './big-dot.component.html',
  styleUrls: ['./big-dot.component.scss']
})

export class BigDotComponent implements OnInit {

  @Input() temperatureUnit: TemperatureUnit;
  @Output() focusAirNote: EventEmitter<any> = new EventEmitter();

  private isInitialized: boolean = false;
  private airNoteListOfDeviceList: Array<Airnote[]>;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
  }

  hasAirNote(xDate: Date, deviceIndex: number): Airnote {
    if (this.airNoteListOfDeviceList[deviceIndex]) {
      const index = this.airNoteListOfDeviceList[deviceIndex].map(
        (airNote: Airnote) => new Date(airNote.timestamp).getTime()).indexOf(xDate.getTime());

      if (index !== -1) {
        return Object.assign({}, this.airNoteListOfDeviceList[deviceIndex][index]);
      }
    }

    return null;
  }

  update(airNoteListOfDeviceList: Array<Airnote[]>, xScale: any, yScale: any, type: string, lineColorList: string[]): void {
    if (airNoteListOfDeviceList) {
      this.airNoteListOfDeviceList = airNoteListOfDeviceList;
      if (airNoteListOfDeviceList.length === 0) {
        d3.select(this.el.nativeElement)
          .selectAll('.air-note-dot')
          .remove();

      } else {
        if (this.isInitialized) {
          d3.select(this.el.nativeElement)
            .selectAll('.air-note-dot')
            .remove();
        }

        for (let i = 0; i < airNoteListOfDeviceList.length; i++) {
          d3.select(this.el.nativeElement)
            .selectAll('air-note-dot')
            .data(airNoteListOfDeviceList[i])
            .enter().append('circle')
            .attr('class', 'air-note-dot')
            .style('stroke', lineColorList[i % 8])
            .style('stroke-width', '1.5px')
            .style('fill', '#FFFFFF')
            .attr('r', 4.5)
            .attr('cx', (d: Airnote) => xScale(new Date(d.timestamp)))
            .attr('cy', (d: Airnote) => (type === 'temp' && this.temperatureUnit === TemperatureUnit.Fahrenheit) ?
              yScale(this.celsiusToFahrenheit(d.content.rawValue)) : yScale(d.content.rawValue))
            .style('pointer-events', 'none');

          this.isInitialized = true;
        }
      }
    }
  }

  celsiusToFahrenheit(celsius: number): number {
    return celsius * 9 / 5 + 32;
  }
}
